// Import utilities
import isDefined from '@automator/utilities/is-defined';

/**
 * Returns the form fields values in an object
 *
 * @param {Node} $form The form node
 * @return {Object}       The form fields
 */
const getFormFields = ( $form ) => {
	const fields = {};

	// Check if the form exists
	if ( isDefined( $form ) ) {
		// Iterate fields
		$form.querySelectorAll( 'input, textarea, select' ).forEach( ( $field ) => {
			try {
				// Get the field value
				fields[$field.getAttribute( 'name' )] = $field.value;
			} catch ( e ) {
				// Check if debugging mode is enabled
				// eslint-disable-next-line
				if ( UncannyAutomatorBackend.debugging.enabled ) {
					// eslint-disable-next-line no-console
					console.warn( `getFormFields: Couldn't get the value of the following field.` );
					// eslint-disable-next-line no-console
					console.log( $field );
				}
			}
		} );
	} else {
		// Check if debugging mode is enabled
		// eslint-disable-next-line
		if ( UncannyAutomatorBackend.debugging.enabled ) {
			// eslint-disable-next-line no-console
			console.error( `getFormFields: The form Node doesn't exist` );
			// eslint-disable-next-line no-console
			console.log( $form );
		}
	}

	return fields;
};

export default getFormFields;
